module.exports = __webpack_public_path__ + "img/f7f319dce3d5da2a4421452d6c303e52.png";